import React, { Component } from "react";
import {
  Button,
  Divider,
  Icon,
  Segment,
  Header,
  Popup,
  Grid,
  Confirm
} from "semantic-ui-react";
import request from "../../utils/request";

class DrumPrinters extends Component {
    constructor(props) {
      super(props);
      this.state = {
        isLoading: false,
        open: false,
        printerId: 0,
        printerEnabled: ""
      };
    }

    open = (id, enabled) => {
        this.setState({ open: true, printerId: id, printerEnabled: enabled });
    }

    close = () => this.setState({ open: false, printerId: 0, printerEnabled: "" });

    activatePrinter = () => {
        this.setState({ open: false, isLoading: true });
        let payload = {
            "printerid": this.state.printerId ? this.state.printerId : 0,
            "newstatus": this.state.printerEnabled ? (this.state.printerEnabled === "yes" ? "disable" : "enable") : ""
        }
        return request.post(this, "drum-printer/status", payload).then(resp => {                
                this.setState({
                    status: resp.status,
                    isLoading: false,                   
                });
                return this.props.pollData();
            }
        );
    };

    render() {
        const { printers, loading } = this.props;
        const { isLoading } = this.state;
        let options = {};
        options = (value) =>  {
            switch (value.printer_status) {
                case 22: case 1822: case 2218:
                    options.img_name = 'green';
                    options.img_title = 'Printer is ready';
                    break;
                case 2230:
                    options.img_name = 'yellow';
                    options.img_title = 'Paper is low';
                    break;
                case 1830: case 12682: case 3018: case 3030: case 60:
                    options.img_name = 'red';
                    options.img_title = 'Printer lid is open';
                    break;
                case 30126: case 12618: case 156:
                    options.img_name = 'red';
                    options.img_title = 'Printer is out of paper';
                    break;
                case 99:
                    options.img_name = 'black';
                    options.img_title = 'Printer is disabled';
                    break
                case 0: default:
                    options.img_name = 'red';
                    options.img_title = 'Printer is offline';
            };
            return options;
        }
        return (
            <div>
                <Segment loading={loading} style={{overflow: 'auto', height: 385 }}>
                    <Header>Drum Printers</Header>
                    <Divider hidden />
                    {printers && printers.map(value => 
                        (
                        <Grid key={value.id}>
                            <Grid.Column width={3}>
                                <Button
                                    className="mini btnDrumPrinters"
                                    onClick={() => this.open(value.id, value.enabled)}
                                    loading={isLoading}
                                    disabled={isLoading}
                                >
                                    <Icon
                                        name={value.enabled === "yes" ? "check" : "close"}
                                        color={value.enabled === "yes" ? "green" : "red"}
                                    />
                                </Button>
                                <Confirm
                                    open={this.state.open}
                                    content={
                                        value.enabled === "yes" ? 
                                        "This printer is currently enabled. Are you sure you want to disable it?" : 
                                        "This printer is currently disabled. Are you sure you want to enable it?"}
                                    onCancel={this.close}
                                    onConfirm={() => this.activatePrinter()}
                                    size="mini"
                                />
                            </Grid.Column>
                            <Grid.Column width={2}>
                                <Popup 
                                    content={options(value).img_title} 
                                    trigger={<Icon name="circle" color={options(value).img_name} />} 
                                />
                            </Grid.Column>
                            <Grid.Column width={7}>{value.host}</Grid.Column>
                            <Grid.Column width={1}>#{value.id}</Grid.Column>
                        </Grid>
                        )
                    )}
                </Segment>
            </div>
        );
    }
}
export default DrumPrinters;